<template>
  <CBreadcrumb class="d-md-down-none me-auto mb-0">
    <CBreadcrumbItem
      v-for="item in breadcrumbs"
      :key="item"
      :href="item.active ? '' : item.path"
      :active="item.active"
    >
      {{ $t('message.breadcrumb.' + item.name) }}
    </CBreadcrumbItem>
  </CBreadcrumb>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import router from '@/router'

const breadcrumbs = ref()

const getBreadcrumbs = () => {
  const current = router.currentRoute.value
  const page = current.query.page

  return current.matched
    .filter((item) => !item.meta.isParent)
    .map((route) => {
      const active = route.name === current.name
      const routePath = route.path.replace(/\/$/, '')
      const isAncestor =
        !active &&
        (current.path === routePath || current.path.startsWith(`${routePath}/`))
      const pageQuery = isAncestor && page ? `?page=${page}` : ''

      return {
        active,
        name: route.name,
        path: `/#${route.path}${pageQuery}`,
      }
    })
}

router.afterEach(() => {
  breadcrumbs.value = getBreadcrumbs()
})

onMounted(() => {
  breadcrumbs.value = getBreadcrumbs()
})
</script>
